export const DASHBOARD_EDITOR_COPY = {
  toast: {
    draftSaving: 'Saving draft...',
    draftSavingDescription: 'Your changes are being saved.',
    draftSaved: 'Draft saved',
    draftSavedDescription: 'Your changes have been saved successfully.',
    draftError: "Couldn't save draft",
    draftErrorDescription: 'There was an issue saving your draft. Check your inputs and try again.',
    publishing: 'Publishing dashboard...',
    publishingDescription: 'Your dashboard is being published.',
    published: 'Dashboard published',
    publishedDescription: 'This dashboard is now available to assigned users.',
    shared: 'Dashboard shared successfully',
    sharedDescription: 'Access has been granted to the selected users and departments.',
    publishError: "Couldn't publish dashboard",
    publishErrorDescription: 'Something went wrong while publishing. Please try again.',
    validationTitle: 'Please complete required fields before publishing.',
    validationNoSection: 'A section must be selected.',
    validationNoTitle: 'A title is required.',
    archived: 'Dashboard archived',
    archivedSuccess: (name = 'Dashboard') => `"${name}" archived successfully.`,
    archiveError: (name = 'Dashboard') => `Couldn't archive ${name}`,
    archiveErrorDescription: 'Please try again',
    archiveRetry: 'Retry',
    unarchivedSuccess: (name = 'Dashboard') => `"${name}" unarchived successfully.`,
    unarchiveError: (name = 'Dashboard') => `Couldn't unarchive ${name}`,
    unarchiveErrorDescription: 'Please try again',
    unarchiveRetry: 'Retry',
    duplicated: (name = 'Dashboard') => `"${name}" duplicated successfully.`,
    duplicateError: (name = 'Dashboard') => `Couldn't duplicate ${name}`,
    duplicateErrorDescription: 'Please try again',
    duplicateRetry: 'Retry',
    error: 'Something went wrong. Please try again.',
  },
  location: {
    alertTitle: 'Placement successfully added',
    alertDescription: 'The dashboard is now assigned to the selected location.',
  },
  emptyState: {
    title: 'Start adding widgets',
    description: 'Customize your dashboard with widgets that assist your team.',
    addButton: 'Add',
  },
};

export const DUPLICATE_MODAL_COPY = {
  title: 'Duplicate Dashboard?',
  body: (name = 'Dashboard Name') =>
    `This will create a copy of "${name}" including its structure and settings. You can edit it after duplicating.`,
  cancelButton: 'Cancel',
  duplicateButton: 'Duplicate',
};

export const ARCHIVE_MODAL_COPY = {
  title: 'Archive dashboard?',
  body: (name = 'Dashboard Name') =>
    `"${name}" will be archived and removed from active dashboards. You can restore it later from archived items.`,
  cancelButton: 'Cancel',
  archiveButton: 'Archive',
};

export const SELECT_LOCATION_COPY = {
  title: 'Select section',
  description:
    'Choose where this dashboard will appear. Available widgets and data sources will depend on the selected section.',
  cancelButton: 'Cancel',
  selectButton: 'Select',
  backButton: 'Back',
  moveHere: 'Move here',
  alertTitle: 'Placement successfully added',
  alertDescription: 'The dashboard is now assigned to the selected location.',
};

export const DASHBOARD_CARD_COPY = {
  menu: {
    edit: 'Edit',
    share: 'Share',
    archive: 'Archive',
    unarchive: 'Unarchive',
    duplicate: 'Duplicate',
  },
};

export const DASHBOARD_LIST_COPY = {
  emptyState: {
    title: 'Start building your dashboard',
    description:
      'Create your first dashboard to manage layouts and widgets for your organization.',
    createButton: 'Create dashboard',
    suggestedTemplates: 'Suggested templates',
  },
  header: {
    title: 'Dashboards',
    description: 'Manage and publish dashboard templates for your organization.',
    createButton: 'New dashboard',
    tabs: {
      created: 'Created',
      templates: 'Templates',
    },
  },
  filters: {
    searchPlaceholder: 'Search',
    statePlaceholder: 'State',
    sectionPlaceholder: 'Section',
    clearButton: 'Clear filters',
    stateOptions: {
      draft: 'Draft',
      published: 'Published',
      archived: 'Archived',
    },
  },
};

export const TEMPLATE_LIST_COPY = {
  emptyState: {
    title: 'No templates available',
    description: 'Templates will appear here when they are created.',
  },
  header: {
    title: 'Templates',
  },
  filters: {
    searchPlaceholder: 'Search',
    sectionPlaceholder: 'Sections',
    categoryPlaceholder: 'Categories',
    clearButton: 'Clear filters',
  },
};

export const DASHBOARD_DETAIL_COPY = {
  editButton: 'Edit dashboard',
  widgetsPlaceholder: 'Widgets preview will be implemented in a separate task.',
};

/** Nombres cortos para tabla de confirmación y resumen "Move · Resize · +2" */
export const EDIT_PERMISSION_SHORT_LABELS = {
  move: 'Move',
  resize: 'Resize',
  rename: 'Rename',
  configure: 'Configure',
};

export const VIEW_PERMISSION_SHORT_LABELS = {
  view_only: 'View only',
  export_data: 'Export data',
};

export const CREATE_PERMISSION_SHORT_LABELS = {
  add_widget: 'Add new widgets',
};

export const SHARE_MODAL_COPY = {
  title: 'Share access to this dashboard',
  searchPlaceholder: 'Search by user name or departments...',
  addButton: 'Add',
  shareButton: 'Share',
  copyLinkButton: 'Copy Link',
  accessInfo: {
    title: 'View who has access',
    userCount: (count = 0) => `${count} users currently have access`,
  },
  toBeAdded: {
    title: 'To be added',
    count: (users = 0, departments = 0) =>
      `You're about to add ${users} user${users !== 1 ? 's' : ''} · ${departments} department${departments !== 1 ? 's' : ''}`,
  },
  sections: {
    users: 'Users',
    departments: 'Departments',
  },
  noResults: 'No results found',
  cancelButton: 'Cancel',
  tooltips: {
    userRole: (role) => role || 'User',
    departmentMembers: (count = 0) => `${count} members`,
  },
  assignedList: {
    removeAssignee: 'Remove',
  },
  permissions: {
    editSection: 'Edit',
    viewSection: 'View',
    createSection: 'Create',
    viewItem: 'View only',
    viewExportItem: 'Export data',
    createItem: 'Add new widgets',
    summaryView: 'Can view',
    summaryEdit: 'Can edit',
    tooltipEmptyEdit: 'No widget permissions selected',
  },
};

export const SHARE_CONFIRMATION_COPY = {
  title: 'Confirm share access',
  recipientsSubtitle: 'Recipients and permissions',
  tableHeaders: {
    name: 'Name',
    canDo: 'Can do',
    accessLevel: 'Access level',
  },
  accessView: 'View',
  accessEdit: 'Edit',
  accessCreate: 'Create',
  accessViewSummary: 'View only',
  warningTitle: 'Verify information before confirming',
  warningBody:
    'Users and departments will receive immediate access to the dashboard with the specified permissions.',
  backButton: 'Back',
  confirmButton: 'Confirm and share',
  userCount: (n) => `${n} user${n !== 1 ? 's' : ''}`,
  departmentCount: (n) => `${n} department${n !== 1 ? 's' : ''}`,
  separator: '|',
};

export const WIDGET_LIBRARY_COPY = {
  title: 'Widgets library',
  description: 'Browse and add widgets to customize your overview.',
  searchPlaceholder: 'Search widgets...',
  addButton: 'Add',
  listItemAddButton: 'Add',
  listItemRemoveButton: 'Remove',
  previewAddButton: '+ Add',
  previewRemoveButton: 'Remove',
  selectedBadgeLabel: 'Selected',
  expandPreviewAriaLabel: 'Expand preview',
  viewModeListTitle: 'List view',
  viewModeGridTitle: 'Grid view',
  cancelButton: 'Cancel',
  categoriesTitle: 'Categories',
  collapseSidebar: 'Collapse categories',
  expandSidebar: 'Expand categories',
  backButton: 'Back',
  widgetDetailAboutTitle: 'About this Widget',
  widgetDetailBestForTitle: 'Best for',
  widgetDetailPreviewLabel: 'Preview',
  widgetDetailAddButton: 'Add',
  allCategory: 'All',
  emptySearch: 'No widgets found',
  emptySearchDescription: 'Try adjusting your search or category filter.',
  selectedAlertTitle: (count) => `${count} Widget${count !== 1 ? 's' : ''} selected`,
};
